export const ja = {
  // Common
  "common.back": "戻る",
  "common.cancel": "キャンセル",
  "common.noItems": "アイテムがありません",
  "common.loading": "読み込み中...",
  
  // Header
  "nav.features": "機能",
  "nav.howItWorks": "使い方",
  "nav.pricing": "料金",
  "nav.faq": "よくある質問",
  "nav.testimonials": "ショーケース",
  "nav.contact": "お問い合わせ",
  "button.getStarted": "始める",
  "button.loading": "読み込み中...",
  
  // Auth related
  "auth.signIn": "サインイン",
  "auth.redirecting": "リダイレクト中...",
  "auth.continueWithGoogle": "Googleで続行",
  "auth.continueWithGithub": "GitHubで続行",
  "auth.or": "または",
  "auth.consent.prefix": "続行することで、当社の",
  "auth.consent.terms": "利用規約",
  "auth.consent.and": "および",
  "auth.consent.privacy": "プライバシーポリシー",
  
  // Site Title
  "site.title": "Communicate to Win",
  "site.title.first": "Communicate",
  "site.title.second": "to Win",
  "site.title.translated": "沟通制勝",
  
  // Hero Section
  "hero.title": "AI搭載コミュニケーションアシスタント",
  "hero.subtitle": "インテリジェントで文脈を理解する回答で会話を変革し、あらゆる状況でより効果的にコミュニケーションを取れるようサポートします。",
  "hero.cta.primary": "無料トライアル開始",
  "hero.cta.secondary": "デモを見る",
  
  // Main Title
  "main.title": "すべての返信を機会に変える",
  
  // Footer Section
  "footer.company": "会社",
  "footer.product": "製品",
  "footer.support": "サポート",
  "footer.legal": "法的事項",
  "footer.contactSupport": "サポートに連絡",
  "footer.helpCenter": "ヘルプセンター",
  "footer.apiDocs": "API文書",
  "footer.statusPage": "ステータスページ",
  "footer.privacyPolicy": "プライバシーポリシー",
  "footer.termsOfService": "利用規約",
  "footer.cookiePolicy": "Cookieポリシー",
  "footer.refundPolicy": "返金ポリシー",
  "footer.copyright": "© 2025 DOUBLEWIND LTD. All rights reserved.",
  "footer.supportLabel": "サポート",
  
  // Features Section
  "features.badge": "強力な機能",
  "features.title": "より良いコミュニケーションに必要なすべて",
  "features.subtitle": "すべての会話をより効果的で専門的にするために設計された包括的なツール。",
  "features.scenario.title": "シナリオテンプレート",
  "features.scenario.description": "職場、個人、学術、専門的なコミュニケーション用の事前構築テンプレート。",
  "features.custom.title": "カスタム入力",
  "features.custom.description": "任意のメッセージやコンテンツを貼り付けて、文脈に適した回答を取得。",
  "features.instant.title": "返信時間を90%短縮",
  "features.instant.description": "数秒でAI作成の返信を取得。待機なし、結果のみ。",
  "features.copy.title": "ワンクリックコピー＆シェア",
  "features.copy.description": "回答を即座にコピーするか、プラットフォームから直接共有。",
  
  // How It Works Section
  "howItWorks.badge": "使い方",
  "howItWorks.title": "より良いコミュニケーションへの3つの簡単なステップ",
  "howItWorks.subtitle": "私たちの合理化されたプロセスにより、あらゆる状況に対して専門的な回答を簡単に生成できます。",
  "howItWorks.step1.title": "シナリオ選択",
  "howItWorks.step1.description": "ニーズに最も適したコミュニケーションシナリオを選択。",
  "howItWorks.step2.title": "コンテンツ貼り付け",
  "howItWorks.step2.description": "返信が必要なメッセージやコンテンツを追加。",
  "howItWorks.step3.title": "AI回答取得",
  "howItWorks.step3.description": "数秒で専門的で文脈に沿った回答を受信。",
  
  // Pricing Section
  "pricing.title": "料金",
  "pricing.subtitle": "コミュニケーションニーズに合ったプランを選択",
  "pricing.plan.free": "Free",
  "pricing.plan.pro": "Pro",
  "pricing.plan.business": "Enterprise",
  "pricing.free.price": "$0",
  "pricing.pro.price": "$9.99",
  "pricing.business.price": "$29.99",
  "pricing.period": "/月",
  "pricing.free.description": "サービスを試すのに最適",
  "pricing.pro.description": "プロフェッショナルや頻繁なユーザーに理想的",
  "pricing.business.description": "チームや組織向け",
  "pricing.popular": "最も人気",
  "pricing.free.feature1": "月10回の返信",
  "pricing.free.feature2": "基本シナリオ",
  "pricing.free.feature3": "テンプレート定義・使用",
  "pricing.free.feature4": "履歴返信記録",
  "pricing.pro.feature1": "月200回の返信",
  "pricing.pro.feature2": "基本+カスタムシナリオ",
  "pricing.pro.feature3": "テンプレート定義・使用",
  "pricing.pro.feature4": "履歴返信記録",
  "pricing.pro.feature5": "高度なカスタマイズ",
  "pricing.business.feature1": "無制限の返信",
  "pricing.business.feature2": "チームコラボレーション",
  "pricing.business.feature3": "基本+カスタムシナリオ",
  "pricing.business.feature4": "テンプレート定義・使用",
  "pricing.business.feature5": "履歴返信記録",
  "pricing.business.feature6": "高度なカスタマイズ",
  "pricing.cta.trial": "無料トライアル開始",
  "pricing.cta.subscribe": "購読",
  "pricing.cta.contact": "営業に連絡",
  "pricing.cta.current": "現在のプラン",
  "pricing.currentPlan": "現在のプラン:",
  "pricing.endDate": "現在のプラン終了日:",
  "pricing.autoRenewalDate": "現在のプラン自動更新日:",
  "pricing.answersLeft": "残り返信数:",
  "pricing.planName.free": "Freeプラン",
  "pricing.planName.proMonthly": "Proプラン-月額",
  "pricing.planName.proYearly": "Proプラン-年額",
  "pricing.planName.maxMonthly": "Enterpriseプラン-月額",
  "pricing.planName.maxYearly": "Enterpriseプラン-年額",
  "pricing.autoRenews": "返信数の自動更新日:",
  "pricing.needMore": "もっと返信が必要ですか？",
  "pricing.upgradeBelow": "以下でプランをアップグレード",
  "pricing.doNotRollOver": "未使用の返信は繰り越されません",
  "pricing.willCancelOn": "キャンセル日:",
  "pricing.downgradeScheduled": "ダウングレードが予定されています。次のプランに変更されます",
  "pricing.on": "日時:",
  "pricing.upgradeImmediateTitle": "プランがアップグレードされました",
  "pricing.upgradeImmediateDesc": "新しいプランが有効になりました。",
  "pricing.downgradeScheduledTitle": "ダウングレードが予定されています",
  "pricing.downgradeScheduledDesc": "次の更新時にプランが変更されます。",
  "pricing.cancelScheduledTitle": "キャンセルが予定されています",
  "pricing.cancelScheduledDesc": "プランは期間終了時に終了します。",
  "pricing.cancelResumedTitle": "キャンセルが削除されました",
  "pricing.cancelResumedDesc": "サブスクリプションは引き続き更新されます。",
  "pricing.cancelPendingDowngrade": "キャンセル",
  "pricing.pendingDowngradeCanceledTitle": "保留中のダウングレードがキャンセルされました",
  "pricing.pendingDowngradeCanceledDesc": "プランは変更されません。",
  "pricing.pendingDowngradeCancelFailedTitle": "キャンセル失敗",
  "pricing.pendingDowngradeCancelFailedDesc": "保留中のダウングレードをキャンセルできませんでした。もう一度お試しください。",
  "pricing.cancelPendingDowngradeProcessing": "処理中...",
  "pricing.scheduled": "予定済み",
  "pricing.processing": "処理中...",
  "pricing.getMoreReplies": "返信数を増やす",
  "pricing.oneTimeTitle": "アカウントに返信数を追加",
  "pricing.oneTimeAmountLabel": "金額 (USD)",
  "pricing.repliesUnit": "返信",
  "pricing.oneTimeNotice": "購入した返信数は現在の月次サイクルでのみ有効です。使用するには有効な有料サブスクリプションが必要で、未使用の返信は繰り越されません。",
  "pricing.cancel": "キャンセル",
  "pricing.proceed": "続行",
  "pricing.confirmUpgradeTitle": "アップグレードの確認",
  "pricing.confirmDowngradeTitle": "ダウングレードの確認",
  "pricing.confirmUpgradeDesc": "プランをアップグレードしようとしています。変更は即時に有効になり、比例配分された料金（またはクレジット）が適用される場合があります。",
  "pricing.confirmDowngradeDesc": "ダウングレードを予定しようとしています。現在の機能は現在の請求期間の終了まで維持されます。",
  "pricing.downgradeEffectNote": "ダウングレードでは現在のサイクルの返金は行われません。",
  "pricing.downgradeApplyNextCycle": "新しいプランは更新時に自動的に開始されます。",
  "pricing.confirmCancel": "戻る",
  "pricing.confirmProceedUpgrade": "今すぐアップグレード",
  "pricing.confirmProceedDowngrade": "ダウングレードを予定",

  // FAQ Section
  "faq.title": "よくある質問",
  "faq.subtitle": "communicate2winについて知っておくべきすべて",
  "faq.q1": "どのようなコミュニケーションシナリオがサポートされていますか？",
  "faq.a1": "職場コミュニケーション、人間関係、学術通信、カスタマーサービス、営業アプローチなど、多くのシナリオをサポートしています。私たちのAIは各状況に必要な文脈とトーンに適応します。",
  "faq.q2": "回答の生成速度はどのくらいですか？",
  "faq.a2": "私たちのAIは数秒で回答を生成します。品質を損なうことなく速度を優先し、専門的な回答を即座に提供します。",
  "faq.q3": "いつでも購読をキャンセルできますか？",
  "faq.a3": "はい、いつでも購読をキャンセルできます。長期契約はなく、必要に応じてプランをダウングレードまたはアップグレードできます。",
  "faq.q4": "データは安全でプライベートですか？",
  "faq.a4": "はい、暗号化、アクセス制御、定期的なセキュリティ監査を含む包括的なセキュリティ対策を実施しています。入力コンテンツと生成された回答は、回答レビューやテンプレート作成などの機能を有効にするためにユーザー履歴の一部として保存されます。アカウント設定からいつでも履歴データを削除できます。",
  "faq.q5": "Replies を使い切ったらどうなりますか？",
  "faq.a5": "Free ユーザーは次の月次サイクルまでクォータ更新を待つ必要があります。Pro にアップグレード後、Replies が不足した場合は追加の一回購入 Replies を購入できます。追加分は現在の月次サイクル内のみ有効です。Enterprise ユーザーは無制限の Replies を利用できます。",
  "faq.q6": "どの言語がサポートされていますか？",
  "faq.a6": "現在英語をサポートしており、スペイン語、フランス語、ドイツ語、その他の主要言語への拡張を計画しています。AIは多言語コミュニケーションを効果的に処理できます。",
  
  // Testimonials Section
  "testimonials.title": "コミュニケーションショーケース",
  "testimonials.subtitle": "公開メッセージ、メール、AI洗練された回答であなた自身のインスピレーションを",
  "testimonials.sarah.name": "サラ・ジョンソン",
  "testimonials.sarah.title": "マーケティングディレクター",
  "testimonials.sarah.quote": "communicate2winはクライアントコミュニケーションの処理方法を変革しました。回答は専門的で、毎週数時間を節約してくれます。",
  "testimonials.michael.name": "マイケル・チェン",
  "testimonials.michael.title": "営業マネージャー",
  "testimonials.michael.quote": "職場シナリオテンプレートは非常に正確です。このツールを使用してから回答率が40%向上しました。",
  "testimonials.emily.name": "エミリー・ロドリゲス",
  "testimonials.emily.title": "カスタマーサクセスリード",
  "testimonials.emily.quote": "困難な顧客状況の処理に最適です。AIは文脈とトーンを完璧に理解します。",
  
  // Interface Elements
  "interface.generating": "回答生成中...",
  "interface.generate": "AI回答生成",
  "interface.processing": "処理中...",
  
  // History and Showcase
  "history.shareToShowcase": "ショーケースに共有",
  "history.showcased": "ショーケース済み",
  "history.shareConfirm": "この投稿をショーケースに共有しますか？この操作は投稿を削除しない限り元に戻せません。",
  "history.sharedBy": "共有者:",
  "interface.copy": "コピー",
  "interface.share": "共有",
  "interface.shareResponse": "回答を共有",
  "interface.shareNative": "システム経由で共有",
  "interface.shareEmail": "メール",
  "interface.copyShareText": "リンク付きでコピー",
  "interface.shareTextCopied": "回答とリンクがクリップボードにコピーされました。",
  "interface.ready": "生成準備完了",
  "interface.enterMessage": "メッセージ内容を入力してシナリオを選択し、AI搭載回答を開始してください。",
  "interface.fast": "高速",
  "interface.accurate": "正確",
  "interface.professional": "プロフェッショナル",
  "interface.translation": "翻訳",
  "interface.responseDescription": "文脈に合わせた思慮深く専門的な回答です：",
  "interface.multipleOptions": "複数の回答オプション：",
  "interface.option": "オプション",
  "interface.noContent": "コンテンツがありません",
  
  // Placeholders
  "placeholder.message": "返信するメッセージ、メールコンテンツ、または受信したテキストを貼り付けてください...",
  
  // Dropdowns
  "dropdown.useTemplates": "テンプレートを使用",
  "dropdown.scenario": "シナリオなし",
  "dropdown.target": "ターゲットなし",
  "dropdown.tone": "トーンなし",
  
  // Scenario Options
  "scenario.email": "メール",
  "scenario.message": "メッセージ",
  "scenario.workplace": "職場",
  "scenario.school": "学校",
  "scenario.home": "家庭",
  "scenario.business": "ビジネス",
  "scenario.academic": "学術",
  "scenario.social": "ソーシャル",
  "scenario.formal": "フォーマル",
  "scenario.casual": "カジュアル",
  "scenario.professional": "プロフェッショナル",
  "scenario.personal": "個人",
  "scenario.customerService": "カスタマーサービス",
  "scenario.interview": "面接",
  "scenario.presentation": "プレゼンテーション",
  
  // Target Options
  "target.lover": "恋人",
  "target.friend": "友人",
  "target.boss": "上司",
  "target.colleague": "同僚",
  "target.classmate": "クラスメイト",
  "target.parents": "両親",
  "target.child": "子供",
  "target.teacher": "先生",
  "target.student": "学生",
  "target.client": "クライアント",
  "target.customer": "顧客",
  "target.stranger": "見知らぬ人",
  "target.family": "家族",
  "target.sibling": "兄弟姉妹",
  "target.neighbor": "隣人",
  "target.mentor": "メンター",
  "target.supplier": "サプライヤー",
  "target.serviceProvider": "サービスプロバイダー",
  "target.partner": "パートナー",
  "target.subordinate": "部下",
  
  // Tone Options
  "tone.humorous": "ユーモラス",
  "tone.serious": "真剣",
  "tone.happy": "幸せ",
  "tone.angry": "怒り",
  "tone.mischievous": "いたずら",
  "tone.polite": "丁寧",
  "tone.casual": "カジュアル",
  "tone.formal": "フォーマル",
  "tone.friendly": "フレンドリー",
  "tone.confident": "自信",
  "tone.apologetic": "謝罪",
  "tone.enthusiastic": "熱狂的",
  
  // Status Messages
  "status.copied": "コピーしました！",
  "status.copyDescription": "回答がクリップボードにコピーされました。",
  "status.copyWithTranslationDescription": "回答と翻訳がクリップボードにコピーされました。",
  "status.success": "回答が正常に生成されました。",
  "status.successWithTranslation": "翻訳付きで回答が生成されました。",
  "status.successWithoutTranslation": "回答が正常に生成されました。",
  "status.error": "生成に失敗しました",
  "status.errorDescription": "回答の生成に失敗しました。もう一度お試しください。",
  "status.enterContent": "コンテンツを入力してください",
  "status.enterContentDescription": "返信したいメッセージを追加してください。",
  
  // Pro/Max subscriber restrictions
  "restriction.descriptionOptional": "説明（オプション）",
  "restriction.descriptionLabel": "説明（Pro / Enterprise購読者のみ）",
  "restriction.proMaxOnly": "* Pro / Enterprise購読者のみ",
  "restriction.desPrompt": "より良い回答を生成するのに役立つ文脈、背景情報、または特定の要件を入力してください...",
  
  // Demo functionality for non-logged-in users
  "demo.title": "返信するメッセージを選択",
  "demo.option1": "営業開拓（コールドアプローチ）",
  "demo.option2": "「価格が高い」という探りへの対応",
  "demo.option3": "面接自己紹介（30秒版）",
  "demo.option4": "メール返信",
  "demo.option5": "「既読スルー」見込み客へのフォローアップ",
  "demo.option6": "エレベーターピッチ（30秒）",
  "demo.runDemo": "デモ実行",
  "demo.inputContent": "入力内容：",
  "demo.scenario": "シナリオ：",
  "demo.target": "ターゲット：",
  "demo.tone": "トーン：",
  "demo.description": "説明：",

  // Showcase Page
  "showcase.title": "コミュニケーションショーケース",
  "showcase.subtitle": "コミュニティが共有したAI搭載のインスピレーションとなるコミュニケーションを発見",
  "showcase.userPrefix": "公開コミュニケーション by",
  "showcase.backAll": "すべてのショーケースに戻る",
  "showcase.sortBy": "並び替え：",
  "showcase.sort.newest": "新しい順",
  "showcase.sort.oldest": "古い順",
  "showcase.sort.scenario": "シナリオ別",
  "showcase.sort.target": "ターゲット別",
  "showcase.sort.tone": "トーン別",
  "showcase.filter.scenario": "シナリオ：",
  "showcase.filter.target": "ターゲット：",
  "showcase.filter.tone": "トーン：",
  "showcase.filter.all": "すべて",
  "showcase.loading": "ショーケースを読み込み中...",
  "showcase.loadingUser": "ユーザーのコミュニケーションを読み込み中...",
  "showcase.loadingMore": "さらに読み込み中...",
  "showcase.none.userTitle": "まだ公開コミュニケーションがありません",
  "showcase.none.globalTitle": "ショーケースアイテムがまだありません",
  "showcase.none.userDesc": "このユーザーはまだショーケースにコミュニケーションを共有していません。",
  "showcase.none.globalDesc": "最初のAIコミュニケーションをショーケースに共有してください！",
  "showcase.messageDetails": "メッセージ詳細",
  "showcase.field.date": "日付",
  "showcase.field.scenario": "シナリオ",
  "showcase.field.target": "ターゲット",
  "showcase.field.tone": "トーン",
  "showcase.originalMessage": "元のメッセージ",
  "showcase.description": "説明",
  "showcase.aiResponse": "AI回答",

  // Templates
  "templates.saveAsTemplate": "テンプレートとして保存",
  "templates.saved": "テンプレートが保存されました",
  "templates.saveSuccess": "テンプレートが正常に保存されました",
  "templates.title": "マイテンプレート",
  "templates.new": "新しいテンプレート",
  "templates.loading": "読み込み中...",
  "templates.none": "テンプレートが見つかりません",
  "templates.name": "名前",
  "templates.scenario": "シナリオ",
  "templates.target": "ターゲット",
  "templates.tone": "トーン",
  "templates.description": "説明",
  "templates.save": "保存",
  "templates.saving": "保存中...",
  "templates.delete": "テンプレートを削除",
  "templates.deleteConfirm": "このテンプレートを削除しますか？",
  "templates.deleteFailed": "テンプレートの削除に失敗しました",
  "templates.nameRequired": "* テンプレート名を入力してください",
  "templates.deleteSuccess": "テンプレートが正常に削除されました",
  "templates.saveFailed": "テンプレートの保存に失敗しました",

  // History Modal additions
  "history.messageDetails": "メッセージ詳細",
  "history.messageDetailsDesc": "元の入力とAI生成回答を含むメッセージ詳細の表示と管理。",
  "history.field.date": "日付",
  "history.field.scenario": "シナリオ",
  "history.field.target": "ターゲット",
  "history.field.tone": "トーン",
  "history.originalMessage": "元のメッセージ",
  "history.aiResponse": "AI回答",
  "history.description": "説明",
  "history.listTitle": "メッセージ履歴",
  "history.listDesc": "会話履歴の閲覧、フィルタリング、管理。メッセージをクリックして詳細を表示。",
  "history.sortBy": "並び替え：",
  "history.sort.newest": "新しい順",
  "history.sort.oldest": "古い順",
  "history.sort.scenario": "シナリオ別",
  "history.sort.target": "ターゲット別",
  "history.sort.tone": "トーン別",
  "history.filter.scenario": "シナリオ：",
  "history.filter.target": "ターゲット：",
  "history.filter.tone": "トーン：",
  "history.filter.all": "すべて",
  "history.loading": "履歴を読み込み中...",
  "history.loadingMore": "さらに読み込み中...",
  "history.none": "メッセージが見つかりません",
  "history.showing": "{total}件中{current}件を表示",
  "history.allLoaded": "すべてのメッセージが読み込まれました",
  "history.scrollMore": "スクロールしてさらに表示",
  "history.loadMoreButton": "さらに読み込む",
  "history.deleteMessage": "メッセージを削除",
  "history.deleting": "削除中...",
  "history.deleteSuccess": "メッセージ記録が正常に削除されました",
  "history.deleteFailed": "メッセージ記録の削除に失敗しました。もう一度お試しください",
  "history.confirmDeleteTitle": "削除の確認",
  "history.confirmDeleteSubtitle": "この操作は元に戻せません",
  "history.confirmDeleteDesc": "このメッセージ記録を削除してもよろしいですか？",
  "history.confirmDeleteAction": "削除を確認",
  "history.shareTitle": "ショーケースに共有",
  "history.shareSubtitle": "このメッセージを公開する",
  "history.sharing": "共有中...",
  "history.confirmShareAction": "共有を確認",
  "history.shareSuccess": "メッセージがショーケースに正常に共有されました",
  "history.shareFailed": "ショーケースへの共有に失敗しました。もう一度お試しください",

  // User Menu
  "userMenu.myAccount": "マイアカウント",
  "userMenu.history": "履歴",
  "userMenu.templates": "テンプレート",
  "userMenu.signOut": "ログアウト",
  
  // Hero Showcase / Demo Tabs / Previews
  "hero.preview.aiReply": "AI回答プレビュー",
  "hero.preview.scenarioLabel": "シナリオ",
  "hero.cta.tryNow": "無料で始める",
  "hero.cta.learnMore": "詳細を見る",
  "hero.cta.getStarted": "無料で始める",
  "hero.preview.primary": "トーンを磨く",
  "hero.preview.secondary": "翻訳",
  "hero.preview.tone": "フレンドリー",
  "hero.preview.target": "クライアント",
  "hero.hook": "毎日コミュニケーション能力を向上させている何千ものユーザーに参加してください。",
  "hero.headline": "AI搭載コミュニケーションアシスタント",
  "hero.subheadline": "粗いアイデアを数秒で洗練された文脈に適した回答に変換します。",
  
  // Stats
  "stats.users": "ユーザー",
  "stats.replies": "回答",
  "stats.languages": "言語",
  
  // Marquee / Logos
  "marquee.trusted": "パートナー / サポート",
  "marquee.aria": "ブランドロゴ",
  
  // Interface Elements (additional)
  "interface.advancedOptions": "高度なオプション",
  "interface.clearInput": "入力をクリア",
  "interface.clearDescription": "説明をクリア",
  
  // Demo short tab titles (mapped from demo option ids)
  "demo.shortTitle.salesOpener": "営業開拓",
  "demo.shortTitle.priceObjection": "価格探り",
  "demo.shortTitle.interviewIntro": "面接紹介",
  "demo.shortTitle.emailReply": "メール返信",
  "demo.shortTitle.followUp": "フォローアップ",
  "demo.shortTitle.elevatorPitch": "エレベーターピッチ",
  
  // Demo path / response overlay
  "demoTabs.pathPrefix": "demo",
  "demoTabs.response": "response",
  "demoTabs.inputPrompt": "入力プロンプト",
  "demoTabs.context": "コンテキスト",
  "demoTabs.description": "説明",
  "demoTabs.generate": "生成",
  "demoTabs.aiOutput": "AI出力",
  "demoTabs.sample": "サンプル",
  "demoTabs.streaming": "ストリーミング中...",
  
  // Preview sections
  "preview.section.scenarioTemplates.title": "シナリオ & テンプレート",
  "preview.section.scenarioTemplates.subtitle": "シナリオを素早く選択するか、保存されたテンプレートを適用します。テンプレートは説明/ターゲット/トーンを事前入力するため、高品質な生成を即座に開始できます。",
  "preview.section.customInputs.title": "カスタム入力",
  "preview.section.customInputs.subtitle": "コア入力 + オプション説明 + 高度なシナリオ/ターゲット/トーン選択器。自由に組み合わせて文脈に適した結果を得られます。",
  "preview.section.cutReplyTime.title": "回答時間を90%短縮",
  "preview.section.cutReplyTime.subtitle": "手動作成とAIアシストを比較。並列オプション + 内蔵翻訳で修正ループを削減。",
  "preview.section.copyShare.title": "ワンクリックコピー & シェア",
  "preview.section.copyShare.subtitle": "統一されたトップアクションで複数オプションをレイアウト：全てコピー / シェア / オプション別コピー。翻訳は自動的に追加されます。",
  
  "preview.templates.my": "マイテンプレート",
  "preview.templates.new": "新規",
  "preview.manualFlow": "手動フロー",
  "preview.aiAssisted": "AIアシスト",
  
  // Manual flow bullet steps
  "preview.manualFlow.step1": "構造とトーンを計画",
  "preview.manualFlow.step2": "開始部分を下書き / 削除して書き直し",
  "preview.manualFlow.step3": "丁寧さと文法を調整",
  "preview.manualFlow.step4": "用語を調べて翻訳を確認",
  "preview.manualFlow.step5": "ターゲットアプリに貼り付け",
  
  "preview.copyAll": "全てコピー",
  "preview.share": "シェア",
  "preview.enPlusTranslation": "英語 + 翻訳",
  "preview.translationAppendNote": "(*) 全てコピー時に翻訳が自動的に追加されます。",
  "preview.field.scenario": "シナリオ",
  "preview.field.target": "ターゲット",
  "preview.field.tone": "トーン",
  "preview.auto": "自動",
  "preview.step.pasteOrTemplate": "リクエストを貼り付けまたはテンプレートを選択",
  "preview.step.optionalDescription": "(オプション) 説明/シナリオを追加",
  "preview.step.pickOption": "生成されたオプションを1つ選択",
  "preview.step.copyShareTranslate": "ワンクリックコピー / シェア / 翻訳",
  "preview.time.manual": "5-8分",
  "preview.time.ai": "30-40秒",
  
  "testimonials.more": "ギャラリーをクリックして完全なショーケースを探索"
}